// Copyright Epic Games, Inc. All Rights Reserved.

import { Link, styled } from "@material-ui/core";

export const EpicLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.primary.light,
  "&:hover": {
    textDecoration: "underline",
  },
}));
